import { $, _ } from "../../../../helpers/dom-selectors.js";
import makeForms from "../../../global-components/forms/forms.js";
import APP_EVENTS from "../init/events.js";
const forms = $(document, '.form');
const showsForms = makeForms({
    forms,
    overlayEl: _('resultOverlay'),
    entity: 'Show',
    events: APP_EVENTS,
    action: 'add-show-clicked'
});
const APP_COMPONENTS = Object.freeze({
    showsForms
});
export default APP_COMPONENTS;
